import { configureStore as configureStoreToolkit } from '@reduxjs/toolkit';
// import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import setBrowserFingerPrint from '../redux-middleware/set-browser-fingerprint.js';
import storage from 'redux-persist/lib/storage';

const logger = () => next => action => next(action);

const crashReporter = store => next => action => {
  try {
    return next(action);
  } catch (err) {
    console.error('Caught an exception!', err);
    // Raven.captureException(err, {
    //   extra: {
    //     action,
    //     state: store.getState()
    //   }
    // });
    throw err;
  }
};

// Pass Root Reducer to get configureStore

const createConfigureStore = (rootReducer, isProd) => initialState => {
  const middlewares = [
    setBrowserFingerPrint(false),
    // Add other middleware on this line...

    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
    logger,
    crashReporter
  ];

  if (!isProd) {
    // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
    // middlewares.push(reduxImmutableStateInvariant());
    // composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools
  }

  const persistConfig = {
    key: 'root',
    storage: storage,
    whitelist: [
      'products',
      'grid',
      'gridPDP',
      // 'request',
      'requestPDP',
      'eossCouponsReducer',
      'RecentSearches',
      'fleek'
    ]
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = configureStoreToolkit({
    reducer: persistedReducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: false,

      // serializableCheck: {
      //   ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      // },
    }).concat([...middlewares])
  });

  const persistor = persistStore(store);
  if (module.hot && !isProd) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers').default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }


  return { store, persistor };
};

export default createConfigureStore;
